export default __webpack_public_path__ + "static/media/image-heading.png?.51e6ca9d";